import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { ClickOutsideModule } from 'ng-click-outside';

import { AutocompleteModule } from './components/autocomplete/autocomplete.module';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';

//COMPONENTS
import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { VerticalMenuComponent } from "./vertical-menu/vertical-menu.component";
import { CustomizerComponent } from './customizer/customizer.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';

//DIRECTIVES
import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";
import { SidebarLinkDirective } from './directives/sidebar-link.directive';
import { SidebarDropdownDirective } from './directives/sidebar-dropdown.directive';
import { SidebarAnchorToggleDirective } from './directives/sidebar-anchor-toggle.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { TopMenuDirective } from './directives/topmenu.directive';
import { TopMenuLinkDirective } from './directives/topmenu-link.directive';
import { TopMenuDropdownDirective } from './directives/topmenu-dropdown.directive';
import { TopMenuAnchorToggleDirective } from './directives/topmenu-anchor-toggle.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { NoFutureDateValidatorDirective } from './directives/noFutureDateValidator';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { EntityFormReadonlyDirective } from './directives/entity-form-readonly.directive';
import { AssignerBulkUploadModalComponent } from './assigner-bulk-upload/assigner-bulk-upload-modal.component';
import { SuperAdminRecipeBulkUploadModalComponent } from './super-admin-recipe-bulk-upload/super-admin-recipe-bulk-upload-modal.component';
import { SuperAdminRecipeBulkUploadRowEditorComponent } from './super-admin-recipe-bulk-upload/super-admin-recipe-bulk-upload-row-editor.component';
import { SuperAdminFinishProductBulkUploadModalComponent } from './super-admin-finish-product-bulk-upload/super-admin-finish-product-bulk-upload-modal.component';
import { SuperAdminFinishProductBulkUploadRowEditorComponent } from './super-admin-finish-product-bulk-upload/super-admin-finish-product-bulk-upload-row-editor.component';
import { SuperAdminSupplementBulkUploadModalComponent } from './super-admin-supplement-bulk-upload/super-admin-supplement-bulk-upload-modal.component';
import { SuperAdminSupplementBulkUploadRowEditorComponent } from './super-admin-supplement-bulk-upload/super-admin-supplement-bulk-upload-row-editor.component';

// Super Admin RDMS recipe / finish-product / supplement bulk upload components

@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FooterComponent,
        NavbarComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        CustomizerComponent,
        NotificationSidebarComponent,
        EmptyStateComponent,
        ToggleFullscreenDirective,
        SidebarDirective,
        TopMenuDirective,
        NgbModule,
        TranslateModule,
        NoFutureDateValidatorDirective,
        OnlyNumberDirective,
        EntityFormReadonlyDirective,
        NgSelectModule,
        AssignerBulkUploadModalComponent,
        SuperAdminRecipeBulkUploadModalComponent,
        SuperAdminRecipeBulkUploadRowEditorComponent,
        SuperAdminFinishProductBulkUploadModalComponent,
        SuperAdminFinishProductBulkUploadRowEditorComponent,
        SuperAdminSupplementBulkUploadModalComponent,
        SuperAdminSupplementBulkUploadRowEditorComponent,
    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        TranslateModule,
        FormsModule,
        OverlayModule,
        ReactiveFormsModule,
        PerfectScrollbarModule,
        ClickOutsideModule,
        AutocompleteModule,
        PipeModule,
        NgbModule,
        NgSelectModule,
    ],
    declarations: [
        FooterComponent,
        NavbarComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        CustomizerComponent,
        NotificationSidebarComponent,
        EmptyStateComponent,
        ToggleFullscreenDirective,
        SidebarLinkDirective,
        SidebarDropdownDirective,
        SidebarAnchorToggleDirective,
        SidebarDirective,
        TopMenuLinkDirective,
        TopMenuDropdownDirective,
        TopMenuAnchorToggleDirective,
        TopMenuDirective,
        NoFutureDateValidatorDirective,
        OnlyNumberDirective,
        EntityFormReadonlyDirective,
        AssignerBulkUploadModalComponent,
        SuperAdminRecipeBulkUploadModalComponent,
        SuperAdminRecipeBulkUploadRowEditorComponent,
        SuperAdminFinishProductBulkUploadModalComponent,
        SuperAdminFinishProductBulkUploadRowEditorComponent,
        SuperAdminSupplementBulkUploadModalComponent,
        SuperAdminSupplementBulkUploadRowEditorComponent,
    ]
})
export class SharedModule { }
